<template>
<div class="layout-person">
    
    <slot name="person-header" v-bind:parent="parent">
        <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header uk-margin-top">
            <div class="uk-light uk-container uk-container-small uk-text-center">
                <router-link :to="`/${$route.params.pathMatch.join('/')}`" class="text-green"><label>BACK</label></router-link>
                <h1 class="uk-margin-small-top">{{person.title}}</h1>
                <h4 class="uk-margin-remove"><label class="text-blue">{{person.subtitle}}</label></h4>
            </div>
        </div>
    </slot>

    <div class="square uk-background-cover uk-card uk-card-default" v-bind:style="{ backgroundImage: `url(${person?.image?.smallSquare})` }" v-if="person?.image.smallSquare"></div>
    
    <slot name="default">
        <div class="uk-section uk-section-medium uk-background-white">
            <div class="uk-container uk-container-tiny uk-margin-bottom uk-margin-large-top">
                <h3 v-if="person.summary" class="uk-text-center">
                    <em class="text-light-blue">{{person.summary}}</em>
                </h3>
            </div>
            
            <div class="uk-container uk-container-small" v-if="person.content">
                <div class="content" v-html="person.content"></div>
            </div>
        </div>
    </slot>    

</div>
</template>

<script>

// import _ from 'lodash'
import gql from 'graphql-tag'

// GraphQL query
const readOnePerson = gql`
    query($urlSegment: String!, $fullPath: String!) {
        readOnePerson(filter: { urlSegment: { eq: $urlSegment }}) {
            title
            urlSegment
            subtitle
            content
            summary
            link
            image {
                smallSquare
                mediumSquare
            }
        }
        readOnePeoplePage(filter: { fullPath: { eq: $fullPath }}) {
            title
            urlSegment
            subtitle
            summary
            link
            image {
                smallSquare
                mediumSquare
            }
        }
    }
`

export default {
    props: ['page', 'parent'],
    data() {
        return {
            person: {}
        }
    },
    apollo: {
        readOnePerson: {
            query: readOnePerson,
            variables() {
                return {
                    urlSegment: this.$route.params.personId,
                    fullPath: this.$route.params.pathMatch.join('/')
                }
            },
            manual: true,
            result ({ data, loading }) {
                if (!loading) {
                    this.person = data.readOnePerson;
                }
            },
            loadingKey: 'loading'
        }
    }
}
</script>